export default {
  'areas.maintitle': 'Quản lý khu vực',
  'areas.create': 'Thêm khu vực mới',
  'areas.update': 'Chỉnh sửa khu vực',
  'areas.infomation': 'Thông tin khu vực',

  'areas.areaslist': 'Danh sách khu vực',

  'areas.provinceCodes': 'Tỉnh thành trực thuộc',
  'areas.action': 'Hành động',
  'areas.totalLocation': 'Tổng số địa điểm',

  'areas.name': 'Tên khu vực',
  'areas.name.placeholder': 'Vui lòng nhập tên khu vực',
  'areas.description': 'Mô tả',
  'areas.description.placeholder': 'Vui lòng nhập mô tả',
  'areas.provinces': 'Tỉnh thành trực thuộc',
  'areas.selectProvinces.placeholder': 'Vui lòng chọn tỉnh thành',

  'areas.add': 'Thêm',
  'areas.edit': 'Cập nhật',
  'areas.cancel': 'Hủy',

  'areas.deleteconfirm': 'Bạn có xác nhận xóa khu vực này',
};
